import React from 'react'

import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

const FamilyRecord = (props) => {
  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>FAMILIA</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Religión</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Nombre del padre</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Nombre de la madre</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Nombre de los hermanos</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Relación de los padres</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Mascotas</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Lo que más le gusta de su familia</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Lo que menos le gusta de su familia</b>} secondary='Sin definir' />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default FamilyRecord